// Flickity (vendor.js) sets aria-hidden="true" on carousel cells that aren't
// the active slide, but it only ever manages that one attribute - it doesn't
// touch tabindex on the cell's own focusable children (the "Add to cart"
// button, variant links, etc.), so those stay reachable by keyboard/screen
// reader while visually off-screen. Mirroring aria-hidden onto a matching
// tabindex="-1" (and restoring the original tabindex when aria-hidden is
// removed) fixes this without touching the vendored library.
(function () {
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';
  var ORIGINAL_TABINDEX_ATTR = 'data-a11y-restore-tabindex';

  function syncFocusability(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    var focusable = el.querySelectorAll(FOCUSABLE_SELECTOR);
    for (var i = 0; i < focusable.length; i++) {
      var node = focusable[i];
      if (hidden) {
        if (!node.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
          node.setAttribute(ORIGINAL_TABINDEX_ATTR, node.getAttribute('tabindex') || '');
        }
        node.setAttribute('tabindex', '-1');
      } else if (node.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
        var original = node.getAttribute(ORIGINAL_TABINDEX_ATTR);
        if (original) {
          node.setAttribute('tabindex', original);
        } else {
          node.removeAttribute('tabindex');
        }
        node.removeAttribute(ORIGINAL_TABINDEX_ATTR);
      }
    }
  }

  function initAriaHiddenFocusFix() {
    document.querySelectorAll('.flickity-slider > [aria-hidden]').forEach(syncFocusability);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        syncFocusability(mutation.target);
      });
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true,
    });
  }

  // Shopify's video_tag filter renders a fallback <img> inside <video> (for
  // browsers without video support) with no way to pass it an alt attribute
  // through Liquid. It's a decorative fallback for an autoplaying background
  // video, so an empty alt (marking it decorative, not missing) is the
  // correct fix rather than a full description.
  function fixVideoPosterAlt() {
    document.querySelectorAll('video img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function init() {
    initAriaHiddenFocusFix();
    fixVideoPosterAlt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
